import React, { useMemo } from "react";
import { useGetMerchant } from "../apiHooks";
import DescriptionList from "../../../components/molecules/DescriptionList";
import Loader from "components/atoms/Loader";
import { MerchantDataType } from "modules/merchants/types";

const Info = ({ id }: any) => {
  const { data, isLoading } = useGetMerchant(id);
  const listData: any = useMemo(() => {
    const res = [];
    let key: keyof MerchantDataType;
    for (key in data) {
      res.push({ title: [key], value: data?.[key] });
    }
    return res;
  }, [data]);
  if (isLoading) {
    return <Loader formOverlay />;
  }
  return <DescriptionList list={listData} />;
};

export default Info;
